import { render, staticRenderFns } from "./CaseSending.vue?vue&type=template&id=02b926f1"
import script from "./CaseSending.vue?vue&type=script&lang=js"
export * from "./CaseSending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports